import { getMarkerAccessibilityLabel } from "../../utils/label";
$ const {
  selectionState,
  itemCards = [],
  itemCardControls,
  animationDelay = 0,
} = input;
$ const itemCard = itemCards[state.itemIndex]?.itemCard;
$ const isPreviewCardVisible = input.isPreviewCardEnabled && selectionState === "selected" && itemCards.length > 0;
$ const previewCardPositionClasses = [state.previewHorizontalPosition, state.previewVerticalPosition].filter(Boolean);
$ const isStackedMarker = itemCards.length > 1;
$ const stackedMarkerCount = itemCards.length - 1;

<if(itemCards.length > 0)>
  $ const priceTitle = itemCards[state.itemIndex]?.markerTitle?.textSpans?.[0].text || "";
  $ const cardTitle = itemCards[state.itemIndex]?.itemCard?.card?.title?.textSpans?.[0].text || "";
  $ const imgSrc = itemCards[state.itemIndex]?.thumbnail.URL;
  $ const contentKey = isStackedMarker ? (stackedMarkerCount > 1 ? "multipleListingMarker" : "doubleListingMarker") : "singleListingMarker";
  $ const accessibilityLabel = getMarkerAccessibilityLabel({
    mapAccessibilityTexts: input.mapAccessibilityTexts,
    contentKey,
    itemsTotal: stackedMarkerCount,
    itemTitle: cardTitle,
    itemPrice: priceTitle,
  });

  <div
    data-testid="map-marker"
    aria-label=accessibilityLabel
    class=["map-marker", isStackedMarker && "map-stacked-cluster", selectionState]
    style={ "animation-delay": `${animationDelay}s` }
  >
    <if(isStackedMarker && !isPreviewCardVisible)>
      <div class="map-stacked-cluster-count">
        <span>+${stackedMarkerCount}</span>
      </div>
    </if>
    <div class="map-marker-wrapper">
      <if(!isPreviewCardVisible)>
        <div class="map-marker-image">
          <img src=imgSrc alt=cardTitle>
        </div>
      </if>

      <if(priceTitle)>
        <div class="map-marker-title">
          <span title=priceTitle>
            ${priceTitle}
          </span>
        </div>
      </if>
    </div>
    <div class="map-marker-shadow"/>

    <if(itemCard)>
      <div data-testid="map-marker-preview" class=["map-marker-preview", ...previewCardPositionClasses, isPreviewCardVisible ? "visible" : "hidden"]>
        <preview-item
          model=itemCard
          itemIndex=state.itemIndex
          itemsTotal=itemCards.length
          itemCardControls=itemCardControls
          on-close("onPreviewClose")
          on-previous-item("onPreviousItem")
          on-next-item("onNextItem")
        />
      </div>
    </if>
  </div>
</if>
